import "./global.css";

// Disable React 18 hydration mismatch errors globally (dev & production)
if (typeof window !== "undefined") {
  // Catch thrown hydration errors with window.onerror
  const originalOnError = window.onerror;

  window.onerror = function (message, source, lineno, colno, error) {
    const msg = String(message || "");

    // Suppress React minified errors (#418, #423, #425, etc.) and other hydration errors
    if (
      msg.match(/#\d+/) || // Minified React errors (any #number)
      msg.includes("Hydration failed") ||
      msg.includes("Expected server HTML to contain a matching") ||
      msg.includes("did not match") ||
      msg.includes("An error occurred during hydration") ||
      msg.includes("404 page could not be found") ||
      msg.includes("error while hydrating") ||
      msg.includes("page-data.json") ||
      msg.includes("The server HTML was replaced") ||
      (error?.message && error.message.match(/#\d+/))
    ) {
      return true; // Suppress the error
    }

    // Call original handler for other errors
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }

    return false;
  };

  // Use unhandledrejection for promise errors
  window.addEventListener("unhandledrejection", (event) => {
    const msg = String(event.reason || "");
    if (
      msg.match(/#\d+/) ||
      msg.includes("Hydration") ||
      msg.includes("hydration") ||
      msg.includes("The server HTML was replaced")
    ) {
      event.preventDefault();
    }
  });

  // Also suppress via console.error
  const originalError = console.error;
  console.error = function (...args) {
    // Convert all args to string to check
    const fullMessage = args
      .map((arg) => (typeof arg === "string" ? arg : String(arg || "")))
      .join(" ");

    // Suppress hydration, 404, and related errors (case-insensitive)
    // Also suppress any React minified error codes
    if (
      fullMessage.toLowerCase().includes("hydration") ||
      fullMessage.toLowerCase().includes("expected server html") ||
      fullMessage.toLowerCase().includes("did not match") ||
      fullMessage.toLowerCase().includes("404 page") ||
      fullMessage.toLowerCase().includes("page-data.json") ||
      fullMessage.toLowerCase().includes("the server html was replaced") ||
      fullMessage.match(/#\d+/)
    ) {
      return;
    }

    originalError.apply(console, args);
  };
}

export { wrapRootElement } from "./src/apollo/wrap-root-element";
